import React from 'react'

import AdminLayout from '../components/AdminLayout'

import './reports.css'

const quickReports = [
  ['Daily Operations', 'reports-tile--a'],
  ['Weekly Summary', 'reports-tile--b'],
  ['Inventory Valuation', 'reports-tile--a'],
  ['Monthly Performance', 'reports-tile--c'],
  ['Compliance Summary', 'reports-tile--d'],
  ['Manpower Summary', 'reports-tile--c'],
] as const

const Reports = () => {
  return (
    <AdminLayout title="Reports" activeNav="reports" pageTitle="Reports - Namami Gange">
      <div className="admin-card-grid">
        <div className="admin-stat-card">
          <h3>Total Reports</h3>
          <div className="admin-stat-value">923</div>
          <div className="admin-stat-sub">All time</div>
        </div>
        <div className="admin-stat-card">
          <h3>Generated Reports</h3>
          <div className="admin-stat-value">18</div>
          <div className="admin-stat-sub">12% vs yesterday</div>
        </div>
        <div className="admin-stat-card">
          <h3>Scheduled Reports</h3>
          <div className="admin-stat-value">12</div>
          <div className="admin-stat-sub">Upcoming</div>
        </div>
        <div className="admin-stat-card">
          <h3>Downloads</h3>
          <div className="admin-stat-value">86</div>
          <div className="admin-stat-sub">Today</div>
        </div>
      </div>

      <div className="admin-panel">
        <h2>Quick Reports</h2>
        <div className="reports-quick">
          {quickReports.map(([label, cls]) => (
            <button key={label} type="button" className={`reports-tile ${cls}`}>
              <span className="reports-tile-plus" aria-hidden>
                +
              </span>
              {label}
            </button>
          ))}
        </div>
      </div>
    </AdminLayout>
  )
}

export default Reports
